module.exports = __webpack_public_path__ + "workspace/static/img/notificationCenterTwo.8918b92.png";